/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createMatrixClass } from '../../factoriesAny.js';
export var MatrixDependencies = {
  createMatrixClass
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesMatrixClass.generated.js
// module id = null
// module chunks = 